import styled from 'styled-components';
import { CONTENT_ALIGNMENT } from '@pperform/pp-constants/widgetConfigs';
import { mediaBreakpointUp } from 'styles/grid';

export const Container = styled.div<{ alignment: CONTENT_ALIGNMENT }>`
  // matches the padding of Tracking Details's Body
  padding: 16px 12px;
  font-weight: 700;
  display: flex;
  justify-content: ${({ alignment }) => alignment};
  background-color: ${({ theme }) =>
    theme.configs.trackingDetailsBox.headerAndFooter.bgColor};
  color: ${({ theme }) => theme.configs.mainBox.fontColor};
  font-size: ${({ theme }) => theme.configs.fonts.fontSize.additionalDetails}px;
  background-image: ${({ theme }) => {
    const {
      isGradient,
      gradientRatio,
      firstBgColor,
      firstBgColorDensity,
      secondBgColor,
      secondBgColorDensity,
    } = theme.configs.trackingDetailsBox.headerAndFooter;
    if (isGradient) {
      return `linear-gradient(${gradientRatio}deg, ${firstBgColor} ${firstBgColorDensity}%, ${secondBgColor} ${secondBgColorDensity}%)`;
    }
    return 'none';
  }};

  ${mediaBreakpointUp.md} {
    padding: 16px 32px;
  }
`;
